import rest from 'Services/restFootData';
import { SubmissionError } from 'redux-form';
import qs from 'query-string';

const groups = ['read'];

// Browse a bookmaker's imported odds (match_odds collection scoped to the
// bookmaker), with combinable competition / tournament / season / team filters
// and pagination. read_match_details + _match + _tournament so each odd carries
// its match label, date, competition, phase and tournament (FDA !1742).
// Returns { collection, totalItems }.
export function fetchBookmakerOdds(bookmakerId, filters = {}) {
  const params = {
    bookmaker: bookmakerId,
    // read_match_details (single read_ group) exposes the embedded match's
    // phase object, which carries longName (phase) + tournament (name/season).
    groups: ['read_match_details', '_match', '_tournament'],
    partial: 0,
    itemsPerPage: filters.itemsPerPage || 20,
    page: filters.page || 1,
    'order[match.date]': 'desc',
  };
  if (filters.competition) {
    params['match.phase.tournament.competition'] = filters.competition;
  }
  if (filters.tournament) {
    params['match.phase.tournament'] = filters.tournament;
  }
  if (filters.season) {
    params['match.phase.tournament.season'] = filters.season;
  }
  if (filters.team) {
    params['match.matchTeams.teamSeason.team'] = filters.team;
  }

  return function() {
    return rest.get('match_odds', { params }).then(
      res => ({
        collection: (res.data && res.data.collection) || [],
        totalItems: (res.data && res.data.totalItems) || 0,
      }),
      () => ({ collection: [], totalItems: 0 })
    );
  };
}

export function getBookmaker(id) {
  const params = {
    groups,
  };
  return function(dispatch) {
    dispatch({ type: 'GET_BOOKMAKER' });

    return rest
      .get(`bookmakers/${id}`, { params })
      .then(
        res => dispatch({ type: 'GET_BOOKMAKER_FULFILLED', payload: res.data }),
        err => dispatch({ type: 'GET_BOOKMAKER_REJECTED', payload: err.response })
      );
  };
}

export function fetchBookmakers(search) {
  const params = {
    itemsPerPage: 10,
    ...qs.parse(search),
    partial: 0,
  };

  return function(dispatch) {
    dispatch({ type: 'FETCH_BOOKMAKER_LIST' });

    return rest
      .get('bookmakers', { params })
      .then(
        res => dispatch({ type: 'FETCH_BOOKMAKER_LIST_FULFILLED', payload: res.data }),
        err => dispatch({ type: 'FETCH_BOOKMAKER_LIST_REJECTED', payload: err.response })
      );
  };
}

export function fetchAllBookmakers() {
  const params = {
    groups: ['read_link'],
    'order[priority]': 'asc',
    'pagination[enablePagination]': 0,
  };

  return function(dispatch) {
    dispatch({ type: 'FETCH_BOOKMAKER_LIST' });

    return rest
      .get('bookmakers', { params })
      .then(
        res => dispatch({ type: 'FETCH_BOOKMAKER_LIST_FULFILLED', payload: res.data }),
        err => dispatch({ type: 'FETCH_BOOKMAKER_LIST_REJECTED', payload: err.response })
      );
  };
}

export function updateBookmaker(id, bookmaker) {
  const params = {
    groups,
  };

  return function(dispatch) {
    dispatch({ type: 'UPDATE_BOOKMAKER', payload: id });

    return rest.put(`bookmakers/${id}`, bookmaker, { params }).then(
      res => {
        dispatch({
          type: 'ADD_NOTIFICATION',
          payload: { messageKey: 'message_bookmakerUpdated', type: 'success' },
        });
        return dispatch({
          type: 'UPDATE_BOOKMAKER_FULFILLED',
          payload: res.data,
        });
      },
      err => {
        if (err.response && err.response.data.type === 'ConstraintViolationList') {
          const { errors } = err.response.data;
          throw new SubmissionError(errors);
        }
        return dispatch({
          type: 'UPDATE_BOOKMAKER_REJECTED',
          payload: err.response,
        });
      }
    );
  };
}
